import request from '@/utils/request'
// 获取商家列表
export function listUser(data) {
  return request({
      url: '/system/user/list',
      method: 'get',
      params: data
  })
}
// 商家信息修改
export function editUser(data) {
  return request({
      url: '/system/user/edit',
      method: 'post',
      data: data
  })
}
// 用户认证列表
export function listAuth(data) {
  return request({
      url: '/system/user/listAuth',
      method: 'get',
      params: data
  })
}
// 个人信息认证审核
export function auditAuth(data) {
  return request({
      url: '/system/user/auditAuth',
      method: 'post',
      data: data
  })
}

